import firebase from "store/firebase";
import "firebase/firestore";
import { AnyAction, Dispatch } from "redux";
import { StoreError } from "store/errors";
import { normalizeDisplayName } from "../users/utils";
import { AccountProfile } from "./reducer";

export const ACTION_ACCOUNT_SAVING = "account/saving";
export const ACTION_ACCOUNT_SAVED = "account/saved";
export const ACTION_ACCOUNT_SAVE_ERROR = "account/save_error";
export const ACTION_ACCOUNT_SAVE_RESET = "account/save_reset";

export type SaveAccountInput = {
  email: string;
  displayName: string | null;
};

/** Persist the user's display name to users/<email> via merge — preserves
 *  any other fields (e.g. `hasChampionBelt`) that other features manage. */
export default function save({ email, displayName }: SaveAccountInput) {
  return async (dispatch: Dispatch<AnyAction>) => {
    if (!email) {
      dispatch({
        type: ACTION_ACCOUNT_SAVE_ERROR,
        payload: new StoreError("No current user."),
      });
      return;
    }
    dispatch({ type: ACTION_ACCOUNT_SAVING, payload: true });
    try {
      const normalized = normalizeDisplayName(displayName);
      await firebase
        .firestore()
        .collection("users")
        .doc(email)
        .set({ email, displayName: normalized }, { merge: true });
      const profile: AccountProfile = {
        id: email,
        email,
        displayName: normalized,
      };
      dispatch({ type: ACTION_ACCOUNT_SAVED, payload: profile });
    } catch (err) {
      const error =
        err instanceof StoreError
          ? err
          : new StoreError(err instanceof Error ? err.message : String(err));
      dispatch({ type: ACTION_ACCOUNT_SAVE_ERROR, payload: error });
    }
    dispatch({ type: ACTION_ACCOUNT_SAVING, payload: false });
  };
}

export function resetSave() {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch({ type: ACTION_ACCOUNT_SAVE_RESET });
  };
}
